import { JobScopeChangeStatus as JobScopeChangeStatusProto } from '@taxfyle/api-internal/internal/job_scope_change_pb'
import { type JobScopeChangeStatus } from '@/features/jobs/job-scope-changes/JobScopeChange'

export function mapJobScopeChangeStatusProtoToJobScopeChangeStatus(
  status: JobScopeChangeStatusProto,
): JobScopeChangeStatus {
  switch (status) {
    case JobScopeChangeStatusProto.ACCEPTED:
      return 'Accepted'
    case JobScopeChangeStatusProto.PENDING_ADMIN_APPROVAL:
      return 'PendingAdminApproval'
    case JobScopeChangeStatusProto.PENDING_CLIENT_APPROVAL:
      return 'PendingClientApproval'
    case JobScopeChangeStatusProto.REJECTED:
      return 'Rejected'
    case JobScopeChangeStatusProto.PENDING_FINALIZATION:
      return 'PendingFinalization'
    case JobScopeChangeStatusProto.APPLY_FAILED:
      return 'ApplyFailed'
    case JobScopeChangeStatusProto.UNSPECIFIED:
      return 'Unspecified'
  }
}
